export const formatDate = (isoStr) => {
  if (!isoStr) return "";
  const date = new Date(isoStr);
  const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return offsetDate.toISOString().split("T")[0]; // yyyy-MM-dd
};

// `timestamp with time zone` 型 → JST補正不要
export const formatDateTimeLocal = (isoStr) => {
  if (!isoStr) return "";
  const date = new Date(isoStr); // これはすでに JST 表現
  return date.toISOString().slice(0, 16); // yyyy-MM-ddTHH:mm
};

export const getDatesBetween = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const dates = [];

  while (startDate <= endDate) {
    // JST補正：UTC → JST（+9時間）
    const jstDate = new Date(startDate.getTime() + 9 * 60 * 60 * 1000);
    const iso = jstDate.toISOString().split("T")[0];
    dates.push(iso);
    startDate.setDate(startDate.getDate() + 1);
  }

  return dates;
};

export const toJSTDate = (isoDateString) => {
  const date = new Date(isoDateString);
  return new Date(date.getTime() + 9 * 60 * 60 * 1000);
};
